import React from 'react';

const Tooltip = ({ content, children, name, role, email, style }) => (
  <div className={style}>
    { children }
    <div className="tooltip">
      <div className='tooltip-profile-inner'>
        <div className="tooltip-content">
          { content &&
            <p className="small">{ content }</p>
          }
          { email &&
            <p className="small">{ email }</p>
          }
          { role &&
            <div className="role">
              <p className="small capitalized">{ role }</p>
            </div>
          }
        </div>
        <div className="arrow-outer" />
        <div className="arrow-inner" />
      </div>
    </div>
  </div>
);

export default Tooltip;



/** WEBPACK FOOTER **
 ** ./src/components/tooltip/index.js
 **/